import {User} from '@hconnect/apiclient'
import {PermissionTypes, withRoute} from '@hconnect/uikit'
import {useSelector} from 'react-redux'

import {withRouteRequiringPermission} from '../../Molecules/PermissionBoundary'
import {usePermissions} from '../../Permissions'
import {AppState} from '../../Root.store'
import {ManageUser} from '@hconnect/adminconsole/src/pages/ManageUser/ManageUser'
import {UserCreationRolesProvider} from "@hconnect/adminconsole/src/contexts/UserCreationRolesContext";

const ManageUserPilotPage = () => {
  const {adminConsoleGrantedPermissionTypes} = usePermissions()
  const loggedInUserProfile = useSelector<AppState, User | null>(
    (state) => state.userProfile.userProfile
  )
  return (
      <UserCreationRolesProvider>
        <ManageUser
          loggedInUserPermissions={adminConsoleGrantedPermissionTypes}
          loggedInUserProfile={loggedInUserProfile}
         />
      </UserCreationRolesProvider>
  )
}

export const ROUTE = '/managePilot'

withRoute({
  path: ROUTE,
  hideInMainNav: true
})(() => null)

export default withRouteRequiringPermission({
  path: `${ROUTE}/:userId`,
  label: 'Manage User',
  hideInMainNav: true,
  routeProps: {exact: true},
  permissions: [PermissionTypes.VIEW_USERS, PermissionTypes.CHANGE_USERS]
})(ManageUserPilotPage)
